module.exports = __webpack_public_path__ + "static/media/cancel-white.d1f9fae2.svg";